export default "__VITE_ASSET__ea872137__"